module.exports={Earlier:"更早",New:"新增",newNotification:"{newCount} 个新通知",newNotifications:"{newCount} 个新通知",noNotifications:"您没有通知"};